import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Button,
  TextField,
  Stack,
  Box,
  Typography,
  Autocomplete,
  TableContainer,
  Select,
  MenuItem,
} from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useRouteLoaderData } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import {
  Loader,
  GetReadOnlyInputProps,
} from "../../../../../HelperFunctions/HelperFunctions";
import { Field, FieldArray, useFormikContext } from "formik";
import { GetDailyConfigAccounts } from "../../../../../API/nimbleAPI";
import { useEffect } from "react";
import { useRef } from "react";
import { useField } from "formik";

const Import = ({
  profitCenter,
  bankAcc,
  selectedCorp,
  loading,
  setLoading,
  setBankAcc,
  UserPref
}) => {
  const { corporations } = useRouteLoaderData("reconciliation");
  const { values, setFieldValue } = useFormikContext();
  const selectRef = useRef(null);

  const hasProfitCenters = profitCenter.length > 1;
  const isProfitCenterSelected =
    values.selectedProfitCenter && values.selectedProfitCenter !== "select";

  const showBankAccount =
    !loading && (!hasProfitCenters || isProfitCenterSelected);

  useEffect(() => {
    if (showBankAccount && values.selectedProfitCenter) {
      getBanckAccounts();
    }
  }, [values.selectedProfitCenter, showBankAccount]);

  const getBanckAccounts = async () => {
    try {
      const payload = {
        CorporationID: selectedCorp,
        PCID:
          values.selectedProfitCenter === "select"
            ? ""
            : values.selectedProfitCenter,
      };
      const getBankAccList = await GetDailyConfigAccounts(payload);
      const validIds = new Set(getBankAccList.map(item => item?.AccountID));
      setFieldValue(
        "selectedBankAcc",
        validIds.has(values.selectedBankAcc)
          ? values.selectedBankAcc
          : "select",
      );
      setBankAcc(getBankAccList);

      if (getBankAccList.length === 2) {
        if (values.selectedBankAcc === "select") {
          setFieldValue("selectedBankAcc", getBankAccList[1].AccountID);
          setFieldValue("selectedBankAccName", getBankAccList[1].AccountName);
        }
      }
    } catch (error) {
      enqueueSnackbar("Error while getting Bank accounts", {
        variant: "warning",
      });
    } finally {
      // setLoading(false);
    }
  };

  const FileUploadField = ({
    value,
    onChange,
    error = false,
    multiple = false,
  }) => {
    const handleFileChange = (e) => {
      let files = e.currentTarget.files;
      // console.log(files);
      if (!files || files.length === 0) {
        onChange(multiple ? [] : null);
        return;
      }

      const allowedExtensions = ["pdf", "xls", "xlsx", "csv"];
      const fileArray = Array.from(files);

      const invalidFiles = fileArray.filter(
        (f) =>
          !allowedExtensions.includes(f.name.split(".").pop().toLowerCase())
      );
      if (invalidFiles.length > 0) {
        enqueueSnackbar("Only PDF, XLS, XLSX, or CSV files are allowed!", {
          variant: "warning",
        });
        return;
      }

      if (multiple && fileArray.length > 4) {
        enqueueSnackbar(
          "You can upload a maximum of 4 Chargeback files only!",
          { variant: "warning" }
        );
        return;
      }

      onChange(multiple ? fileArray : fileArray[0]);
    };

    const fileNames = multiple
      ? (Array.isArray(value) ? value : []).map((f) => f.name).join(", ")
      : value?.name || "";

    const hasFile = multiple
      ? Array.isArray(value) && value.length > 0
      : value !== null && value !== undefined;

    return (
      // <span title={value?.name || "No file selected"}>
      <span
        title={fileNames || "No file selected"}
        onMouseDown={(e) => e.preventDefault()}
      >
        <TextField
          size="small"
          onClick={(e) => e.stopPropagation()}
          variant="filled"
          // value={value?.name || ""}
          value={fileNames}
          error
          inputProps={{ style: { padding: "10px 12px" } }}
          InputProps={{
            readOnly: true,
            sx: {
              paddingRight: 0,
              border: error ? "1px solid red" : "none",
            },
            endAdornment: (
              <>
                {hasFile && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onChange(multiple ? [] : null);
                    }}
                    onPointerDown={(e) => e.stopPropagation()}
                    sx={{
                      padding: "4px",
                      marginRight: "4px",
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
                <Button
                  component="label"
                  size="small"
                  onPointerDown={(e) => e.stopPropagation()}
                  sx={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    height: "100%",
                    bgcolor: "#92dede",
                    color: "black",
                  }}
                >
                  Browse
                  <input
                    type="file"
                    hidden
                    multiple={multiple}
                    accept=".pdf,.xls,.xlsx,.csv"
                    // onChange={(e) => handleFileChange(e.currentTarget.files[0] || null)}
                    onChange={(e) => handleFileChange(e)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Button>
              </>
            ),
          }}
        />
      </span>
    );
  };

  const ProviderSelect = ({ name, value }) => {
    const [field, , helpers] = useField(name);
    const selectRef = useRef(null);

    return (
      <Select
        {...field}
        inputRef={selectRef}
        displayEmpty
        size="small"
        fullWidth
        value={value || ""}
        MenuProps={{
          autoFocus: false,
          disableAutoFocusItem: true,
        }}
        onChange={(e) => {
          helpers.setValue(e.target.value);
          setTimeout(() => {
            selectRef.current?.blur();
          }, 0);
        }}
        sx={{ backgroundColor: "#f2f2f2" }}
      >
        <MenuItem value="" disabled>
          Select Provider
        </MenuItem>
        <MenuItem value="Amex">Amex</MenuItem>
        <MenuItem value="JP Morgan Chase">JP Morgan Chase</MenuItem>
        <MenuItem value="Payment Insider">Payment Insider</MenuItem>
        <MenuItem value="Shift4">Shift4</MenuItem>
        
        {/* <MenuItem value="Square">Square</MenuItem> */}
      </Select>
    );
  };



  return (
    <>
      <Stack height="100%" gap={3} overflow={"auto"}>
        <Stack width="100%" flexDirection="column" gap={4} alignItems="center">
          <TextField
            value={
              corporations.find((c) => c.ID === values.selectedCorp)?.[
              UserPref ? "LegalName" : "Name"
              ] || ""
            }
            label="Corporation"
            variant="filled"
            sx={{ minWidth: 410 }}
            InputProps={{ readOnly: true }}
          />

          {profitCenter.length > 1 && (
            <Autocomplete
              size="small"
              disableClearable
              options={profitCenter}
              value={
                profitCenter.find(
                  (p) => p.ID === values.selectedProfitCenter
                ) || null
              }
              // value={
              //     profitCenter.filter(p => p.ID !== "select").length === 1
              //         ? profitCenter.filter(p => p.ID !== "select")[0]
              //         : profitCenter.find(p => p.ID === values.selectedProfitCenter) || null
              // }
              getOptionLabel={(option) => option.Name}
              isOptionEqualToValue={(option, value) => option.ID === value.ID}
              onChange={(e, newValue) => {
                setFieldValue("selectedProfitCenter", newValue?.ID || "");
                setFieldValue("selectedBankAcc", "select");
                setFieldValue("selectedBankAccName", "");
              }}
              getOptionDisabled={(option) => option.ID === "select"}
              sx={{ minWidth: 410 }}
              renderInput={(params) => (
                <TextField {...params} label="Profit Center" variant="filled" />
              )}
            />
          )}
          {showBankAccount && (
            <Autocomplete
              size="small"
              disableClearable
              options={bankAcc}
              value={
                bankAcc.find((b) => b.AccountID === values.selectedBankAcc) ||
                null
              }
              getOptionLabel={(option) => option.AccountName}
              isOptionEqualToValue={(option, value) =>
                option.AccountID === value.AccountID
              }
              onChange={(e, newValue) => {
                setFieldValue("selectedBankAcc", newValue?.AccountID || "");
                setFieldValue(
                  "selectedBankAccName",
                  newValue?.AccountName || ""
                );
              }}
              getOptionDisabled={(option) => option.AccountID === "select"}
              sx={{ minWidth: 410 }}
              renderInput={(params) => (
                <TextField {...params}
                  label={
                    <span>
                      Bank Account <span style={{ color: "red", fontSize: "18px" }}>*</span>
                    </span>
                  }
                  variant="filled" />
              )}
              renderOption={(props, option) => (
                <li {...props} style={{ width: "100%", padding: 0 }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                    p={0.5}
                  >
                    <span style={{ fontWeight: 400 }}>{option.AccountName}</span>
                    <span
                      style={{
                        fontSize: "0.75rem",
                        opacity: 0.7,
                        color: "#666",
                      }}
                    >
                      {option.AccountTypeName}
                    </span>
                  </Stack>
                </li>
              )}
            />
          )}
        </Stack>

        <Box
          height={
            hasProfitCenters && showBankAccount
              ? "calc(100% - 230px)"
              : "calc(100% - 150px)"
          }
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography fontSize="9px">File Import</Typography>
            <Typography fontSize="9px">
              Choose file with extension [PDF, .xls or .xlsx ,.csv]
            </Typography>
          </Box>

          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <TableContainer sx={{ overflow: "auto" }}>
              <Table stickyHeader size="small" sx={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    {["Merchant Provider", "Batch file", "Chargeback file"].map(
                      (label) => (
                        <TableCell
                          align="left"
                          key={label}
                          sx={{
                            bgcolor: "#f2f2f2",
                            fontSize: "11px",
                            color: "text.secondary",
                            p: label === "Merchant Provider" ? 0.5 : 0,
                          }}
                        >
                          {label}
                        </TableCell>
                      )
                    )}
                    <TableCell align="right" sx={{ bgcolor: "#f2f2f2" }}>
                      <FieldArray name="files">
                        {({ push }) => (
                          <Button
                            size="small"
                            onClick={() =>
                              push({
                                provider: "",
                                batchFile: null,
                                chargebackFile: null,
                              })
                            }
                            sx={{
                              backgroundColor: "#92dede",
                              color: "black",
                              fontSize: 12,
                              height: 30,
                              fontWeight: 600,
                            }}
                            startIcon={<AddIcon fontSize="small" />}
                          >
                            ADD
                          </Button>
                        )}
                      </FieldArray>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <FieldArray name="files">
                  {({ remove }) => (
                    <TableBody>
                      {values.files.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              p: "2px",
                              minWidth: "130px",
                              maxWidth: "130px",
                            }}
                          >
                            <ProviderSelect
                              name={`files[${index}].provider`}
                              value={row.provider}
                            />

                          </TableCell>

                          <TableCell sx={{ p: "2px" }}>
                            <FileUploadField
                              value={row.batchFile}
                              onChange={(file) => {
                                setFieldValue(
                                  `files[${index}].batchFile`,
                                  file
                                );
                              }}

                            // error={Boolean(touched.files?.[index] && !row.batchFile && !row.chargebackFile)}
                            />
                          </TableCell>

                          <TableCell sx={{ p: "2px" }}>
                            <FileUploadField
                              value={row.chargebackFile}
                              onChange={(file) =>
                                setFieldValue(
                                  `files[${index}].chargebackFile`,
                                  file
                                )
                              }
                              // error={Boolean(touched.files?.[index] && !row.batchFile && !row.chargebackFile)}
                              multiple={row.provider === "JP Morgan Chase"}
                            />
                          </TableCell>

                          <TableCell align="right">
                            <IconButton
                              onClick={() => remove(index)}
                              color="error"
                              disabled={values.files.length === 1}
                            >
                              <RemoveIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </FieldArray>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Stack>
      {loading && <Loader loading={loading} />}
    </>
  );
};

export default Import;
